import NativeHlsVideo from '../../embeds/media/players/vulcanV2Player/engines/native_hls_video/index.js';

export default NativeHlsVideo;
